<template>
  <v-app>
    <v-content v-if="loginDialog">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex pa-0 xs12 sm8 md6 lg4>
            <v-card class="elevation-10">
              <v-toolbar height="48">
                <v-toolbar-title style="padding-top: 5px;">{{ header }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text style="padding: 20px 30px 10px 30px;">
                <v-form class="loginForm">
                  <TextField v-if="!changePassword" prepend-icon="person" type="text" v-model="userName" ref="userName" :keyupEnter="doLogin"/>
                  <TextField v-if="!changePassword" prepend-icon="lock" type="password" v-model="password" :keyupEnter="doLogin"/>
                  <div v-if="!changePassword" @click="openForgotPasswordDialog" class="forgotPassword">{{ $t('pages.login.link.forgotPassword') }}</div>
                  <div v-if="changePassword">{{ $t('pages.login.newPasswordMessage') }}</div>
                  <TextField v-show="changePassword" prepend-icon="lock" ref="newPasswordOne" type="password" v-model="newPassword1"/>
                  <TextField v-show="changePassword" prepend-icon="lock" type="password" v-model="newPassword2"/>
                  <div v-if="loginError !== ''" class="error-message">
                    {{ loginError }}
                  </div>
                  <div v-if="loginError === ''" style="height: 10px;">
                  </div>
                </v-form>
              </v-card-text>
              <v-card-actions style="padding: 0 15px 15px 0;">
                <v-spacer/>
                <v-btn v-if="!changePassword" v-on:click="doLogin" :disabled="loginButtonDisabled">{{ $t('pages.login.button.login') }}</v-btn>
                <v-btn v-if="changePassword" v-on:click="doChangePassword" :disabled="changePasswordButtonDisabled">{{ $t('pages.login.button.changePassword') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-dialog v-model="forgotPasswordDialog" persistent width="450">
      <v-card pa-5>
        <v-card-title class="headline">{{ $t('pages.login.dialog.forgotPassword.header') }}</v-card-title>
        <v-card-text>
          <v-container pa-1>
            <v-layout>
              <v-flex py-3 style="text-align: center;">
                <v-label>
                  {{ $t('pages.login.dialog.forgotPassword.message') }}
                </v-label>
              </v-flex>
              <v-flex>
                <TextField v-model="userName" style="margin-left: 0;"/>
              </v-flex>
            </v-layout>
          </v-container>
          <div v-if="forgotPasswordError !== ''" class="error-message">
            {{ forgotPasswordError }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="doForgotPassword">{{ $t('pages.login.dialog.forgotPassword.button.send') }}</v-btn>
          <v-btn @click="cancel">{{ $t('button.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import TextField from '@/components/TextField'
import axios from 'axios'
import querystring from 'querystring'

export default {
  name: 'Login',
  components: { TextField },
  data () {
    return {
      header: 'Calasdo',
      userName: '',
      password: '',
      loginError: '',
      changePassword: false,
      newPassword1: '',
      newPassword2: '',
      loginDialog: true,
      forgotPasswordDialog: false,
      forgotPasswordError: ''
    }
  },
  mounted () {
    this.$refs.userName.focus()
  },
  computed: {
    loginButtonDisabled: function () {
      return this.userName === '' || this.password === '' || this.password.length < 8
    },
    changePasswordButtonDisabled: function () {
      return this.newPassword1.trim().length < 8 || this.newPassword1.trim().length < 8 || this.newPassword1 !== this.newPassword2
    }
  },
  methods: {
    doLogin () {
      this.loginError = ''
      this.$store.dispatch('session/login', { userName: this.userName, password: this.password })
        .then((response) => {
          let session = this.$store.state.session

          this.changePassword = session.temporaryPassword
          if (this.changePassword) {
            this.$nextTick(() => this.$refs.newPasswordOne.focus())
          } else {
            // Find the first menu in the side bar
            let menuItems = this.$store.state.sidebar.items.filter(i => (!i.roles || this.$store.getters['session/hasRole'](i.roles)) && !(i.excludeRoles && !this.$store.getters['session/hasNotRole'](i.excludeRoles)))
            if (menuItems && menuItems.length > 0 && menuItems[0].routerName) {
              this.$router.push({name: menuItems[0].routerName}).catch(() => {})
            } else {
              this.$router.push({ name: 'Dashboard' })
            }
          }
        })
        .catch((error) => {
          this.loginError = error.message
        })
    },
    doChangePassword () {
      // console.log('Change password in backend')
      let password = this.newPassword1
      axios.post('/backend/ui/user/changePassword', querystring.stringify({ password: password }))
        .then(response => {
          // Find the first menu in the side bar
          let menuItems = this.$store.state.sidebar.items.filter(i => (!i.roles || this.$store.getters['session/hasRole'](i.roles)) && !(i.excludeRoles && !this.$store.getters['session/hasNotRole'](i.excludeRoles)))
          if (menuItems && menuItems.length > 0 && menuItems[0].routerName) {
            this.$router.push({name: menuItems[0].routerName}).catch(() => {})
          } else {
            this.$router.push({ name: 'Dashboard' })
          }
        })
        .catch(error => {
          this.loginError = error.response.data.message
        })
    },
    openForgotPasswordDialog () {
      this.loginDialog = false
      this.forgotPasswordDialog = true
    },
    doForgotPassword () {
      this.forgotPasswordError = ''
      axios.post('/backend/ui/user/forgotPassword', querystring.stringify({ userName: this.userName }))
        .then(response => {
          this.forgotPasswordDialog = false
          this.loginDialog = true
        })
        .catch(error => {
          if (error.response.data.code === 'NOT_FOUND') {
            this.forgotPasswordError = this.$t('pages.login.dialog.forgotPassword.error.notFound', { userName: this.userName })
          } else {
            this.forgotPasswordError = error.response.data.message
          }
        })
    },
    cancel () {
      this.forgotPasswordDialog = false
      this.loginDialog = true
    }
  }
}
</script>

<style scoped>
  .loginForm {
    padding: 0 30px;
  }
  .field {
    margin-top: 0;
    padding-top: 10px;
  }
  .error-message {
    text-align: center;
    font-weight: bold;
    padding: 15px 10px 5px 10px;
  }
  .v-input,
  .v-text-field {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 15px !important;
    margin-bottom: 0 !important;
  }
  .v-input {
    font-size: 13pt !important;
    margin-left: 20px;
    margin-right: 20px;
  }
  .v-btn {
    font-size: 13px !important;
    padding: 0 30px;
    height: 32px !important;
  }
  .v-toolbar__title {
    padding-left: 10px;
    font-size: 20px !important;
  }
  .v-application .primary--text {
    color: #607D8B !important;
    caret-color: #607D8B !important;
  }
  .forgotPassword {
    text-align: right;
    font-size: 10pt;
    color: #607D8B;
    cursor: pointer;
    padding-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue